export default "__VITE_ASSET___5gwwo$M__"